import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    doNotDisputeStatue:{},
    error:'',
    status:'idle'
};

export const doNotDeleteDisputeApi = createAsyncThunk('report-audit/doNotDeleteDisputeApi', async (initialPost) => {
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("Token",accessToken);
    [0,1].includes(initialPost.tr_deleted) && fromData.append("tr_deleted",initialPost.tr_deleted);
    [0,1].includes(initialPost.ex_deleted) && fromData.append("ex_deleted",initialPost.ex_deleted);
    [0,1].includes(initialPost.eq_deleted) && fromData.append("eq_deleted",initialPost.eq_deleted);
    fromData.append("id",initialPost.id);
    let response = await axios.post('form/updateDoNotDisputeStatus',fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const reGenerateResult = createAsyncThunk('report-audit/reGenerateResult', async (initialPost) => {
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("Token",accessToken);
    fromData.append("client_id",1);
    let response = await axios.post('form/reGenerateResult',fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const ReportAuditSlice = createSlice({
    name:'report-audit',
    initialState,
    reducers:{
        blankDoNotDeleteDisputeStatus:(state)=>{
            state.doNotDisputeStatue = {};
        }
    },
    extraReducers:(builder) => {
        builder.addCase(doNotDeleteDisputeApi.fulfilled,(state,action)=>{
            // state.contacts.push(action.payload)
            // state.status="idle";
            state.doNotDisputeStatue = action.payload
        })
    }
});

export const {blankDoNotDeleteDisputeStatus} = ReportAuditSlice.actions;

export default ReportAuditSlice.reducer;